import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let imageManagerMountPromise = null;

export function initImageManagerViewFragment({ onMounted } = {}) {
  registerViewMount('image-manager', () => mountImageManagerView(onMounted));
}

async function mountImageManagerView(onMounted) {
  if (document.getElementById('view-image-manager')) return;
  if (imageManagerMountPromise) return imageManagerMountPromise;

  imageManagerMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/image-manager.html', 'Unable to load image manager view');
    onMounted?.();
  })();

  try {
    await imageManagerMountPromise;
  } catch (error) {
    imageManagerMountPromise = null;
    throw error;
  }
}
